import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-credit-note-report-briefly-officer.component',
  templateUrl: './book-credit-note-report-briefly-officer.component.html',
  styleUrls: ['./book-credit-note-report-briefly-officer.component.scss']
})
export class BookCreditNoteReportBrieflyOfficerComponent implements OnInit {
startDate: string = '';
  endDate: string = '';
  reportType: string = '';
  officerepwise: string = '';
  repName: string = '';
  currentDate = new Date();

  // Raw API Data
  filterData: any[] = [];

  // Grouped Data for Display (one row per office rep)
  groupedData: any[] = [];

  // Grand Total
  grandTotal: number = 0;
  booksellerwise: any;

  constructor(
    private dialogRef: MatDialogRef<BookCreditNoteReportBrieflyOfficerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate || '';
    this.endDate = this.data?.endDate || '';
    this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || '';
    this.repName = this.data?.rep_name || this.data?.repName || '';
         this.booksellerwise = this.data?.booksellerwise || this.data?.booksellerwise || '';
    this.reportType = this.data?.reportType || 'Briefly-Officer';

    this.getCreditNoteData();
  }

  getCreditNoteData(): void {
    const req = {
      start_crdtnote_date: this.startDate,
      end_crdtnote_date: this.endDate,
      office_rep_name: this.officerepwise,
      rep_name: this.repName,
      bill_no: this.data?.bill_no || '',
      book_seller_name: this.booksellerwise,
      crdtnote_no: this.data?.crdtnote_no || '',
      book: this.data?.book || ''
    };

    this.service.getBookCreditNoteReport(req).subscribe({
      next: (res: any) => {
        this.filterData = res || [];
        this.groupDataByOfficeRep();
      },
      error: (err) => {
        console.error('Error fetching Book Credit Note data:', err);
      }
    });
  }

  groupDataByOfficeRep(): void {
    const grouped: { [key: string]: any } = {};

    // Group all records by office_rep_name and sum their amounts
    this.filterData.forEach((item) => {
      const rep = item.office_rep_name || 'Unknown';

      if (!grouped[rep]) {
        grouped[rep] = {
          office_rep_name: rep,
          totalAmount: 0
        };
      }

      // Sum up the credit note amounts
      grouped[rep].totalAmount += parseFloat(item.crdtnote_total) || 0;
    });

    // Convert object to array for HTML iteration
    this.groupedData = Object.values(grouped);

    // Sort by office rep name alphabetically
    this.groupedData.sort((a: any, b: any) => 
      a.office_rep_name.localeCompare(b.office_rep_name)
    );

    // Calculate grand total
    this.grandTotal = this.groupedData.reduce(
      (acc, grp: any) => acc + grp.totalAmount, 
      0
    );
  }

printPage4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) {
    console.error('Print section not found');
    return;
  }

  const printWindow = window.open('', '', 'width=1200,height=900');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>A4 Portrait Report</title>

      <style>
        /* ================= PAGE SETUP ================= */
        @page {
          size: A4 portrait;
          margin: 10mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          box-sizing: border-box;
        }

        body {
          margin: 0;
                   font-family: Arial, sans-serif;
          font-size: 12px;
          color: #000;
          line-height: 1;
        }

        /* ================= PRINT WRAPPER ================= */
        .print-wrapper {
          width: 100%;
        }

        /* ================= TABLE ================= */
        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          border-right: 2px solid #000 !important;
        }

        th, td {
          border: 1px solid #000 !important;
          padding: 6px;
          vertical-align: middle;
          line-height: 1;
          white-space: normal;
          word-break: break-word;
        }

        tr td:last-child,
        tr th:last-child {
          border-right: 2px solid #000 !important;
        }

        /* ================= HEADER (TEXT COLLAPSE FIX) ================= */
        thead th {
          background: #f1f1f1 !important;
          font-weight: bold;
          text-align: center;
          font-size: 13px;
          padding: 12px 8px;
          line-height: 1.4;
          white-space: normal;       /* 🔥 IMPORTANT */
          word-break: break-word;    /* 🔥 IMPORTANT */
        }

        /* Optional: Main title row */
        .office-header-row {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          white-space: normal;
        }

        .subtotal-row {
          background-color: #f4b084 !important;
          font-weight: bold;
        }

        .grand-total-row {
          background-color: #c8753f !important;
          font-weight: bold;
          color: #fff !important;
        }

        /* ================= PAGE BEHAVIOUR ================= */
        thead { display: table-header-group; }
        tfoot { display: table-footer-group; }

        tr, td, th {
          page-break-inside: avoid;
        }

        /* ================= PRINT ONLY ================= */
        @media print {
          .noPrint {
            display: none !important;
          }
        }
      </style>
    </head>

    <body>
      <div class="print-wrapper">
        ${printContent.innerHTML}
      </div>
    </body>
    </html>
  `);

  printWindow!.document.close();
  printWindow!.focus();

  setTimeout(() => {
    printWindow!.print();
    printWindow!.close();
  }, 500);
}

printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) {
    console.error('Print section not found');
    return;
  }

  const printWindow = window.open('', '', 'width=1200,height=900');

  printWindow!.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>A4 Portrait Report</title>

      <style>
        /* ================= PAGE SETUP ================= */
        @page {
          size: A4 portrait;
          margin: 10mm;
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          box-sizing: border-box;
        }

        body {
          margin: 0;
                   font-family: Arial, sans-serif;
          font-size: 12px;
          color: #000;
          line-height: 1;
        }

        /* ================= PRINT WRAPPER ================= */
        .print-wrapper {
          width: 100%;
        }

        /* ================= TABLE ================= */
        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          border-right: 2px solid #000 !important;
        }

        th, td {
          border: 1px solid #000 !important;
          padding: 6px;
          vertical-align: middle;
          line-height: 1;
          white-space: normal;
          word-break: break-word;
        }

        tr td:last-child,
        tr th:last-child {
          border-right: 2px solid #000 !important;
        }

        /* ================= HEADER (TEXT COLLAPSE FIX) ================= */
        thead th {
          background: #f1f1f1 !important;
          font-weight: bold;
          text-align: center;
          font-size: 13px;
          padding: 12px 8px;
          line-height: 1.4;
          white-space: normal;       /* 🔥 IMPORTANT */
          word-break: break-word;    /* 🔥 IMPORTANT */
        }

        /* Optional: Main title row */
        .office-header-row {
          font-size: 15px;
          font-weight: bold;
          text-align: center;
          line-height: 1.5;
          white-space: normal;
        }

        .subtotal-row {
          background-color: #f4b084 !important;
          font-weight: bold;
        }

        .grand-total-row {
          background-color: #c8753f !important;
          font-weight: bold;
          color: #fff !important;
        }

        /* ================= PAGE BEHAVIOUR ================= */
        thead { display: table-header-group; }
        tfoot { display: table-footer-group; }

        tr, td, th {
          page-break-inside: avoid;
        }

        /* ================= PRINT ONLY ================= */
        @media print {
          .noPrint {
            display: none !important;
          }
        }
      </style>
    </head>

    <body>
      <div class="print-wrapper">
        ${printContent.innerHTML}
      </div>
    </body>
    </html>
  `);

  printWindow!.document.close();
  printWindow!.focus();

  setTimeout(() => {
    printWindow!.print();
    printWindow!.close();
  }, 500);
}

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Report');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}